import React, { useState } from "react";
import { ComposableMap, Geographies, Geography, Marker } from "react-simple-maps";
import { FaServer } from "react-icons/fa";
import "../styles/LocationMap.css";

const geoUrl = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

const serverLocations = [
    { city: "Boulder", country: "USA", coordinates: [-105.2705, 40.0150], flag: "🇺🇸" },
    { city: "Bridgetown", country: "Barbados", coordinates: [-59.6167, 13.0975], flag: "🇧🇧" },
    { city: "Innsbruck", country: "Austria", coordinates: [11.3833, 47.2667], flag: "🇦🇹" },
    { city: "Sliema", country: "Malta", coordinates: [14.5045, 35.9122], flag: "🇲🇹" },
    { city: "Vaduz", country: "Liechtenstein", coordinates: [9.5167, 47.1416], flag: "🇱🇮" },
    { city: "Riga", country: "Latvia", coordinates: [24.1052, 56.9496], flag: "🇱🇻" },
    { city: "Kazan", country: "Russia", coordinates: [49.1064, 55.7963], flag: "🇷🇺" },
    { city: "Varna", country: "Bulgaria", coordinates: [27.9167, 43.2000], flag: "🇧🇬" },
    { city: "Sharjah", country: "UAE", coordinates: [55.4038, 25.3463], flag: "🇦🇪" },
    { city: "Manama", country: "Bahrain", coordinates: [50.5832, 26.2235], flag: "🇧🇭" },
    { city: "Tampines", country: "Singapore", coordinates: [103.9456, 1.3530], flag: "🇸🇬" },
    { city: "Zhuhai", country: "China", coordinates: [113.5767, 22.2707], flag: "🇨🇳" },
    { city: "Almaty", country: "Kazakhstan", coordinates: [76.8860, 43.2220], flag: "🇰🇿" },
    { city: "Taichung", country: "Taiwan", coordinates: [120.6736, 24.1477], flag: "🇹🇼" },
    { city: "Incheon", country: "South Korea", coordinates: [126.7052, 37.4563], flag: "🇰🇷" },
    { city: "Saint Peter Port", country: "Guernsey", coordinates: [-2.5499, 49.4598], flag: "🇬🇬" },
    { city: "Kutaisi", country: "Georgia", coordinates: [42.7041, 42.2670], flag: "🇬🇪" },
    { city: "Vanadzor", country: "Armenia", coordinates: [44.4939, 40.8128], flag: "🇦🇲" },
    { city: "Karakol", country: "Kyrgyzstan", coordinates: [78.3936, 42.4907], flag: "🇰🇬" },
    { city: "Narva", country: "Estonia", coordinates: [28.1833, 59.3833], flag: "🇪🇪" },
    { city: "Egilsstaðir", country: "Iceland", coordinates: [-14.3948, 65.2663], flag: "🇮🇸" }
];



const LocationMap = () => {
    const [hoveredLocation, setHoveredLocation] = useState(null);

    return (
        <>
           

            <div className="map-container">
                <ComposableMap
                    projection="geoMercator"
                    projectionConfig={{
                        scale: 140,
                        center: [10, 40],
                        rotate: [0, 0, 0]
                    }}
                    height={400}
                    width={800}
                    style={{
                        width: '100%',
                        height: 'auto'
                    }}
                >
                    <Geographies geography={geoUrl}>
                        {({ geographies }) =>
                            geographies.map((geo) => (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    className="geography"
                                />
                            ))
                        }
                    </Geographies>

                    {serverLocations.map((location, index) => (
                        <Marker key={index} coordinates={location.coordinates}>
                            <circle
                                r={hoveredLocation === location ? 8 : 6}
                                className={`location-dot ${hoveredLocation === location ? 'hovered' : ''}`}
                                onMouseEnter={() => setHoveredLocation(location)}
                                onMouseLeave={() => setHoveredLocation(null)}
                            />
                        </Marker>
                    ))}
                </ComposableMap>

                {hoveredLocation && (
                    <div
                        className="location-tooltip"
                        style={{
                            left: `${(hoveredLocation.coordinates[0] + 180) / 3.6}%`,
                            top: `calc(${(90 - hoveredLocation.coordinates[1]) / 1.8}% - 10px)`,
                        }}
                    >
                        <div className="tooltip-icon">
                            <FaServer />
                        </div>
                        <div className="tooltip-city-country">
                            {hoveredLocation.city}, {hoveredLocation.country} {hoveredLocation.flag}
                        </div>
                        <div className="tooltip-stem" />
                    </div>
                )}
            </div>
        </>
    );
};

export default LocationMap;